var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlinePath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.45 12.98-5.4-5.41a.742.742 0 0 1-.1-.93l1.69-2.67c.47-.74 1.18-1.2 2.01-1.29.93-.09 1.89.27 2.64 1.02l3.03 3.03c.72.72 1.08 1.69.97 2.65-.09.84-.54 1.57-1.24 2.01l-2.67 1.69c-.12.08-.26.12-.4.12-.19 0-.39-.08-.53-.22zm.64-1.48 2.17-1.37c.31-.2.51-.52.55-.91.06-.5-.15-1.03-.54-1.42l-3.03-3.03c-.43-.43-.95-.66-1.42-.59-.38.04-.69.25-.91.6l-1.38 2.16 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 20.43c-.7-.7-1.01-1.67-.88-2.75l.98-8.33c.3-2.52 1.41-3.44 4-3.29l3.92.23c.41.03.73.38.7.79-.03.41-.38.73-.79.7l-3.92-.22c-1.78-.11-2.22.24-2.42 1.97l-.98 8.32c-.07.61.09 1.15.45 1.51.37.36.91.53 1.52.45l8.32-.98c1.75-.21 2.14-.67 1.97-2.39l-.24-3.95c-.02-.41.29-.77.7-.79.41-.03.77.29.79.7l.23 3.92c.24 2.49-.74 3.69-3.29 4l-8.32.98c-.14.03-.3.04-.45.04-.89 0-1.69-.32-2.29-.91z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08 19.95a.754.754 0 0 1 0-1.06l3.04-3.04c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3.04 3.04c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePath);
export default __webpack_public_path__ + "static/media/vuesax-outline-path.c17120815ba813ff78c6539e9aaa2c1d.svg";
export { ForwardRef as ReactComponent };